/**
 * Auditor View Banner
 * Phase 8: Prominent visual indicator when Auditor View is active
 *
 * Shows a banner at the top of the page when viewing in Auditor mode
 * to clearly indicate that some internal information is hidden.
 */

import { Shield, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useViewMode } from '@/contexts/ViewModeContext'

export function AuditorViewBanner() {
  const { isAuditorView, setViewMode } = useViewMode()

  if (!isAuditorView) return null

  return (
    <div className="bg-blue-600 text-white px-4 py-2">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Shield className="h-4 w-4" />
          <span className="text-sm font-medium">
            Auditor View Active
          </span>
          <span className="text-sm text-blue-200 hidden sm:inline">
            — Showing only approved documents and compliance evidence
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setViewMode('internal')}
          className="text-white hover:bg-blue-700 hover:text-white h-7 px-2"
        >
          <span className="hidden sm:inline mr-1">Exit</span>
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
